// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"styles_menuItems__3LJZY","menuItem":"styles_menuItem__1-rj8","right":"styles_right__3QCAL","left":"styles_left__2vZr7"};